/* Wishlist Module */

/*
 * 15 Oct 2026: wishlists are also saved through the Seed Wishlist app
 * (Cloudflare Worker seed-wishlist, via the App Proxy /apps/wishlist/save):
 * - Signed-in customers: saved to their Shopify customer record, so the list
 *   follows them across devices and staff see it in admin; also counted in the
 *   wishlist demand report.
 * - Guests: counted anonymously in the demand report (random browser ID, no
 *   personal data), ONLY if they've allowed analytics in the cookie banner.
 * The browser copy in localStorage is still what everything below reads and
 * writes; snippets/seed-wishlist-account.liquid lines it up with the account
 * on each page load.
 */
var seedWishlistSync = (function () {
  var ITEMS = 'seed__wishlist-items';
  var PENDING = 'seed__wishlist-pending';
  var GUEST = 'seed__wishlist-guest';
  var timer = null;
  var busy = false;
  var again = false;

  function get(key) {
    try {
      return localStorage.getItem(key);
    } catch (e) {
      return null;
    }
  }
  function set(key, value) {
    try {
      localStorage.setItem(key, value);
    } catch (e) {}
  }
  function remove(key) {
    try {
      localStorage.removeItem(key);
    } catch (e) {}
  }
  function account() {
    return window.seedWishlistAccount || null;
  }
  function readIds() {
    var ids = [];
    try {
      ids = JSON.parse(get(ITEMS) || '[]');
    } catch (e) {}
    return Array.isArray(ids) ? ids.filter(Boolean).map(String) : [];
  }
  function newGuestId() {
    var bytes = new Uint8Array(16);
    window.crypto.getRandomValues(bytes);
    return 'g_' + Array.prototype.map.call(bytes, function (b) {
      return ('0' + b.toString(16)).slice(-2);
    }).join('');
  }

  // Shopify's consent API: true when the visitor allowed analytics (or no
  // consent is needed in their region), false if they declined or it's unknown.
  function analyticsAllowed(cb) {
    var S = window.Shopify;
    function check() {
      try {
        cb(!!(S.customerPrivacy && S.customerPrivacy.analyticsProcessingAllowed()));
      } catch (e) {
        cb(false);
      }
    }
    if (S && S.customerPrivacy) return check();
    if (S && typeof S.loadFeatures === 'function') {
      S.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (err) {
        if (err) return cb(false);
        check();
      });
    } else {
      cb(false);
    }
  }

  function post(body, onSaved) {
    busy = true;
    again = false;
    fetch('/apps/wishlist/save', {
      method: 'POST',
      credentials: 'same-origin',
      keepalive: true,
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    })
      .then(function (res) {
        // Leave the pending flag on a failure: the next page load re-sends.
        if (res.ok && !again) onSaved();
      })
      .catch(function () {})
      .then(function () {
        busy = false;
        if (again) send();
      });
  }

  function send() {
    if (busy) {
      again = true;
      return;
    }
    var acc = account();
    if (acc) {
      var guest = get(GUEST);
      var body = { ids: readIds() };
      // A guest list being carried into the account: the app keeps the
      // original dates each piece was first wished for.
      if (guest) body.guest_id = guest;
      post(body, function () {
        remove(PENDING);
        if (guest) remove(GUEST);
      });
      return;
    }
    analyticsAllowed(function (ok) {
      if (!ok || busy) return;
      var guest = get(GUEST);
      if (!guest) {
        guest = newGuestId();
        set(GUEST, guest);
      }
      post({ ids: readIds(), guest_id: guest }, function () {
        remove(PENDING);
      });
    });
  }

  return {
    schedule: function () {
      var acc = account();
      set(PENDING, acc ? acc.customerId : 'guest');
      clearTimeout(timer);
      timer = setTimeout(send, 300);
    },
    init: function () {
      var acc = account();
      if (acc) {
        if (acc.needsSync) this.schedule();
      } else if (get(PENDING) === 'guest' || (readIds().length && !get(GUEST))) {
        // Unsent guest change, or a guest list from before tracking started.
        this.schedule();
      }
    },
  };
})();
window.seedWishlistSync = seedWishlistSync;
seedWishlistSync.init();

var wishlistHeader = (function () {
  return {
    init: function () {
      this.handleCount();
    },
    handleCount: function () {
      const wishlist = document.querySelectorAll('.wishlist__count-bubble');
      const items = JSON.parse(localStorage.getItem('seed__wishlist-items'));
      wishlist.forEach((item) => {
        item.innerText = items !== null && items.length != 0 ? items.length : 0;
      });
    },
  };
})();
wishlistHeader.init();

class ButtonWishlist extends HTMLElement {
  constructor() {
    super();
    this.productId = this.dataset.productId;
    this.action = this.dataset.action || 'remove';
    this.addTooltip = this.dataset.tooltipAdd || 'Add to wishlist';
    this.removeTooltip = this.dataset.tooltipRemove || 'Remove from wishlist';
    this.redirectTooltip = this.dataset.tooltipRedirect || 'Browse wishlist';
    this.tooltipDiv = this.querySelector('.tooltip-content');
    this.init();
  }

  init() {
    this.initializeWishlistStatus();
    this.addEventListener('click', this.onThisClick.bind(this));
  }

  initializeWishlistStatus() {
    const localListProductIds = localStorage.getItem('seed__wishlist-items');
    if (!localListProductIds) return;
    const parseLocalListProductIds = JSON.parse(localListProductIds);
    const isProductIdContained = parseLocalListProductIds.includes(
      this.productId
    );
    if (isProductIdContained) {
      this.classList.add('active');
      if (this.tooltipDiv) {
        if (this.action === 'remove') {
          this.tooltipDiv.textContent = this.removeTooltip;
        } else {
          this.tooltipDiv.textContent = this.redirectTooltip;
        }
      }
    }
  }

  actionWhenClicked(allThisProductIds, isAdd) {
    allThisProductIds.forEach((_this) => {
      if (isAdd === true) {
        _this.classList.add('active');
        const tooltipDiv = _this.querySelector('.tooltip-content');
        if (tooltipDiv) {
          if (this.action === 'remove') {
            tooltipDiv.textContent = this.removeTooltip;
          } else {
            tooltipDiv.textContent = this.redirectTooltip;
          }
        }
      } else {
        const tooltipDiv = _this.querySelector('.tooltip-content');
        if (tooltipDiv) {
          tooltipDiv.textContent = this.addTooltip;
        }
        _this.classList.remove('active');
      }
    });
  }

  onThisClick() {
    const localListProductIds = localStorage.getItem('seed__wishlist-items');
    const allThisProductIds = document.querySelectorAll(
      `button-wishlist[data-product-id="${this.productId}"]`
    );
    let listProductIds = [];
    if (!this.productId) return;
    if (localListProductIds && allThisProductIds.length > 0) {
      // wishlist localstorage exists
      const parseLocalListProductIds = JSON.parse(localListProductIds);
      let isProductIdContained = parseLocalListProductIds.includes(
        this.productId
      );
      if (!isProductIdContained) {
        // case item is not in wishlist
        listProductIds.push(...parseLocalListProductIds, this.productId);
        this.actionWhenClicked(allThisProductIds, true);
      } else {
        // case item is in wishlist
        if (this.action) {
          if (this.action === 'remove') {
            const indexOfProductId = parseLocalListProductIds.indexOf(
              this.productId
            );
            parseLocalListProductIds.splice(indexOfProductId, 1);
            listProductIds.push(...parseLocalListProductIds);
            if (this.closest('.wishlist-page-main')) {
              this.closest('.wishlist-list').remove();
              const product = document.querySelectorAll(
                `.wishlist-page-section .product-item__action button-wishlist`
              );
              if (parseLocalListProductIds.length < 1) {
                document.querySelector('.wishlist-no-product-js').classList.remove('hidden');
              }
            } else {
              this.actionWhenClicked(allThisProductIds, false);
            }
          } else {
            listProductIds.push(...parseLocalListProductIds);
            window.location.href = `${window.shopUrl}${window.Shopify.routes.root}pages/wishlist`;
          }
        } else {
          listProductIds.push(...parseLocalListProductIds);
        }
      }
    } else {
      // wishlist localstorage not exists ==> create new local storage
      listProductIds.push(this.productId);
      this.actionWhenClicked(allThisProductIds, true);
    }
    const stringifyListProductIds = JSON.stringify(listProductIds);
    localStorage.setItem('seed__wishlist-items', stringifyListProductIds);
    seedWishlistSync.schedule();
    wishlistHeader.init();
  }
}
customElements.define('button-wishlist', ButtonWishlist);